<section class="my-5 p-4 border border-[#CCCCCC] rounded-[15px] shadow-[0_4px_6px_rgba(0,0,0,0.25)] mx-auto">
  <!-- Envoltura en formulario -->
  <form (ngSubmit)="aplicarFiltros()">
    <!-- GRID DE FILTROS -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-x-4">
      <ng-container *ngFor="let filtro of filtrosConfig" [ngSwitch]="filtro.tipo">
        <!-- INPUT SIMPLE -->
        <div *ngSwitchCase="'input'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">{{
            filtro.label
            }}</label>
          <input [(ngModel)]="filtros[filtro.key]" [name]="filtro.key" [placeholder]="filtro.label" appTrimInput
            [ngModelOptions]="{ standalone: true }"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm bg-white focus:outline-none focus:ring focus:border-blue-300" />
        </div>

        <!-- SELECT SIMPLE -->
        <div *ngSwitchCase="'select'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">{{
            filtro.label
            }}</label>
          <select [(ngModel)]="filtros[filtro.key]" [name]="filtro.key"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm bg-white focus:outline-none focus:ring focus:border-blue-300">
            <option *ngFor="let opt of filtro.opciones" [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <!-- SELECT CÓDIGO SERVICIO -->

        <div *ngSwitchCase="'select-cod-servicio'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">{{
            filtro.label
            }}</label>
          <input type="text" placeholder="Buscar por código..." [formControl]="filtro.control" [matAutocomplete]="auto"
            appTrimInput
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300" />
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onAutocompleteSelected(filtro)">
            <mat-option *ngFor="
                let opt of filtro.opciones | filterCod : filtro.control.value
              " [value]="opt.cod">
              {{ opt.cod }}
            </mat-option>
          </mat-autocomplete>
        </div>

        <!-- MEDICAMENTOS -->

        <!-- <div *ngSwitchCase="'select-cod-medicamentos'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">{{
            filtro.label
            }}</label>
          <input type="text" placeholder="Buscar producto..." [formControl]="filtro.control" [matAutocomplete]="auto"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300" />
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onAutocompleteSelected(filtro)">
            <mat-option *ngFor="
                let opt of filtro.opciones
                  | filterMedicamentoByName : filtro.control?.value || ''
              " [value]="opt.cod">
              {{ opt.medicamento }}
            </mat-option>
          </mat-autocomplete>
        </div> -->

        <div *ngSwitchCase="'select-cod-medicamentos'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">
            {{ filtro.label }}
          </label>

          <mat-select [formControl]="filtro.control" (selectionChange)="onAutocompleteSelected(filtro)"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm bg-white focus:outline-none focus:ring focus:border-blue-300"
            [panelClass]="'medicamentos-select-panel'">
            <!-- Input de búsqueda dentro del panel -->
            <mat-option>
              <input type="text" [(ngModel)]="filtro.busqueda" (ngModelChange)="filtrarOpcionesMedicamentosCod(filtro)"
                [ngModelOptions]="{ standalone: true }" (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
                (keydown.enter)="$event.stopPropagation()" placeholder="Buscar producto..."
                class="w-full px-3 py-2 border border-gray-300 rounded text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300" />
            </mat-option>

            <!-- Opciones filtradas -->
            <mat-option *ngFor="let opt of filtro.opcionesFiltradas" [value]="opt.cod">
              {{ opt.medicamento }}
            </mat-option>
          </mat-select>
        </div>


        <!-- NOMBRE PRODUCTO -->

        <!-- <div
          *ngSwitchCase="'select-cod-medicamentos-query'"
          class="w-[80%] mb-4"
        >
          <label class="block text-sm text-gray-700 mb-1">{{
            filtro.label
          }}</label>
          <input
            type="text"
            placeholder="Buscar medicamento..."
            [formControl]="filtro.control"
            [matAutocomplete]="auto"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="onAutocompleteSelected(filtro)"
          >
            <mat-option
              *ngFor="
                let opt of filtro.opciones
                  | filterMedicamentoByName : filtro.control?.value || ''
              "
              [value]="opt.medicamento"
            >
              {{ opt.medicamento }}
            </mat-option>
          </mat-autocomplete>
        </div> -->
        <div *ngSwitchCase="'select-cod-medicamentos-query'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">
            {{ filtro.label }}
          </label>

          <mat-select [formControl]="filtro.control" (selectionChange)="onAutocompleteSelected(filtro)"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm bg-white focus:outline-none focus:ring focus:border-blue-300"
            [panelClass]="'medicamentos-select-panel'">
            <!-- Input de búsqueda -->
            <mat-option>
              <input type="text" [(ngModel)]="filtro.busqueda" (ngModelChange)="filtrarOpcionesMedicamentos(filtro)"
                (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()"
                (keydown.space)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                placeholder="Buscar medicamento..." [ngModelOptions]="{ standalone: true }"
                class="w-full px-3 py-2 border border-gray-300 rounded text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300" />
            </mat-option>

            <!-- Opciones filtradas -->
            <mat-option *ngFor="let opt of filtro.opcionesFiltradas" [value]="opt.medicamento">
              {{ opt.medicamento }}
            </mat-option>
          </mat-select>
        </div>

        <!-- TIPO SERVICIO -->

        <div *ngSwitchCase="'tipo-servicio'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">{{
            filtro.label
            }}</label>
          <select [(ngModel)]="filtros[filtro.key]"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm bg-white focus:outline-none focus:ring focus:border-blue-300">
            <option *ngFor="let opt of filtro.opciones" [value]="opt.id">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <!-- EPS -->

        <!-- <div *ngSwitchCase="'select-eps'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">{{
            filtro.label
          }}</label>
          <input
            type="text"
            placeholder="Buscar EPS..."
            [formControl]="filtro.control"
            [matAutocomplete]="auto"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="displayFn"
            (optionSelected)="onAutocompleteSelected(filtro)"
          >
            <mat-option
              *ngFor="
                let opt of filtro.opciones | filterEps : filtro.control.value
              "
              [value]="opt.id"
            >
              {{ opt.nameEPS }}
            </mat-option>
          </mat-autocomplete>
        </div> -->

        <div *ngSwitchCase="'select-eps'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">
            {{ filtro.label }}
          </label>

          <mat-select [formControl]="filtro.control" (selectionChange)="onAutocompleteSelected(filtro)"
            [panelClass]="'eps-select-panel'"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm bg-white focus:outline-none focus:ring focus:border-blue-300">
            <!-- Input de búsqueda dentro del panel -->
            <mat-option>
              <input appTrimInput type="text" [(ngModel)]="filtro.busqueda" (ngModelChange)="filtrarOpciones(filtro)"
                (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()"
                (keydown.space)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                placeholder="Buscar EPS..." [ngModelOptions]="{ standalone: true }"
                class="w-full px-3 py-2 border border-gray-300 rounded text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300" />
            </mat-option>

            <!-- Opciones -->
            <mat-option *ngFor="let opt of filtro.opcionesFiltradas" [value]="opt.id">
              {{ opt.nameEPS }}
            </mat-option>
          </mat-select>
        </div>
        <!-- SELECT-DEPARTAMENTO -->
        <div *ngSwitchCase="'select-depa'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">
            {{ filtro.label }}
          </label>

          <mat-select [formControl]="filtro.control" (selectionChange)="onAutocompleteSelected(filtro)"
            [panelClass]="'eps-select-panel'"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm bg-white focus:outline-none focus:ring focus:border-blue-300">
            <!-- Input de búsqueda dentro del panel -->
            <mat-option>
              <input appTrimInput type="text" [(ngModel)]="filtro.busqueda"
                (ngModelChange)="filtrarOpcionesDepartamentos(filtro)" (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
                (keydown.enter)="$event.stopPropagation()" placeholder="Buscar departamento..."
                [ngModelOptions]="{ standalone: true }"
                class="w-full px-3 py-2 border border-gray-300 rounded text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300" />
            </mat-option>

            <!-- Opciones -->
            <mat-option *ngFor="let opt of filtro.opcionesFiltradas" [value]="opt.nombre">
              {{ opt.nombre }}
            </mat-option>

          </mat-select>
        </div>
        <!-- SELECT-CIUDAD -->
        <div *ngSwitchCase="'select-city'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">
            {{ filtro.label }}
          </label>

          <mat-select [formControl]="filtro.control" (selectionChange)="onAutocompleteSelected(filtro)"
            [panelClass]="'eps-select-panel'"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm bg-white focus:outline-none focus:ring focus:border-blue-300">
            <!-- Input de búsqueda dentro del panel -->
            <mat-option>
              <input appTrimInput type="text" [(ngModel)]="filtro.busqueda"
                (ngModelChange)="filtrarOpcionesCiudad(filtro)" (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
                (keydown.enter)="$event.stopPropagation()" placeholder="Buscar Municipio..."
                [ngModelOptions]="{ standalone: true }"
                class="w-full px-3 py-2 border border-gray-300 rounded text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300" />
            </mat-option>

            <!-- Opciones -->
            <mat-option *ngFor="let opt of filtro.opcionesFiltradas" [value]="opt.cod">
              {{ opt.ciudad }} | {{ getDepartamento(opt.departamento) }}
            </mat-option>

          </mat-select>
        </div>
        <!-- SELECT SOLO LABEL -->
        <div *ngSwitchCase="'select-label'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">{{
            filtro.label
            }}</label>
          <select [(ngModel)]="filtros[filtro.key]" [name]="filtro.key"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm bg-white focus:outline-none focus:ring focus:border-blue-300">
            <option *ngFor="let opt of filtro.opciones" [value]="opt.label">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <!-- SELECT LABEL COLORES -->
        <div *ngSwitchCase="'select-label-colors'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">{{
            filtro.label
            }}</label>
          <select [(ngModel)]="filtros[filtro.key]" [name]="filtro.key"
            class="w-full px-3 py-2 border border-gray-300 rounded text-sm bg-white focus:outline-none focus:ring focus:border-blue-300">
            <option *ngFor="let opt of filtro.opciones" [value]="opt.id">
              {{ opt.label }}
            </option>
          </select>
        </div>


        <!-- DATE RANGE MM/YYYY -->
        <div *ngSwitchCase="'date-range'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">
            {{ filtro.label }}
          </label>
          <!-- DESDE -->
          <mat-form-field appearance="fill" class="w-full mat-flat-field">
            <input matInput [matDatepicker]="pickerDesde" [matDatepickerFilter]="yearFilter"
              placeholder="Desde (MM/YYYY)" [(ngModel)]="filtros[filtro.key + 'Desde']"
              [ngModelOptions]="{ standalone: true }" readonly />

            <mat-datepicker-toggle matSuffix [for]="pickerDesde"></mat-datepicker-toggle>

            <mat-datepicker #pickerDesde startView="multi-year" panelClass="month-only-picker"
              (monthSelected)="onMonthSelected($event, filtro.key, 'Desde', pickerDesde)">
            </mat-datepicker>
          </mat-form-field>
        </div>
        <div *ngSwitchCase="'date-range'" class="w-[80%] mb-4">
          <label class="block text-sm text-gray-700 mb-1">
            {{ filtro.labelEnd || ''}}
          </label>
          <!-- HASTA -->
          <mat-form-field appearance="fill" class="w-full mat-flat-field">
            <input matInput [matDatepicker]="pickerHasta" [matDatepickerFilter]="yearFilter"
              placeholder="Hasta (MM/YYYY)" [(ngModel)]="filtros[filtro.key + 'Hasta']"
              [ngModelOptions]="{ standalone: true }" readonly />


            <mat-datepicker-toggle matSuffix [for]="pickerHasta"></mat-datepicker-toggle>
            <mat-datepicker #pickerHasta startView="multi-year" panelClass="month-only-picker"
              (monthSelected)="onMonthSelected($event, filtro.key, 'Hasta', pickerHasta)">
            </mat-datepicker>
          </mat-form-field>

        </div>

        <!-- ERROR -->
        <p *ngIf="dateRangeRequiredError[filtro.key]" class="text-red-600 text-xs mt-1">
          Debes completar ambas fechas
        </p>

        <p *ngIf="dateRangeError[filtro.key]" class="text-red-600 text-xs mt-1">
          La fecha "Hasta" no puede ser menor que "Desde"
        </p>

      </ng-container>

    </div>

    <!-- BOTÓN AL FINAL -->
    <div class="flex justify-end">
      <button type="submit" [disabled]="tieneErroresFecha()" class="px-2 py-2 bg-color_box text-color_text_box text-[0.9rem] font-semibold rounded-md
         hover:bg-[#8de3d5] transition-colors duration-200
         disabled:opacity-50 disabled:cursor-not-allowed">
        Filtrar
      </button>

    </div>
  </form>
</section>